<template><div><h1 id="auslieferungssystem-steuertabelle" tabindex="-1"><a class="header-anchor" href="#auslieferungssystem-steuertabelle"><span>Auslieferungssystem Steuertabelle</span></a></h1>
<p>Auslieferungssystem Steuertabelle — Parametrisiert das Auslieferungssystem</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle wird definiert, für welche Kombination von Auftragsart und Verarbeitungsart die Auslieferungs-Steuercodes aktiv sind, d.h. für welche Kombinationen der Benutzer einen Eintrag in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.aufsteuer.html" title="Steuertabelle WBS">Steuertabelle WBS</RouteLink> machen kann bzw. bei welchen Kombinationen die Avisierungsregeln der Tabelle <RouteLink to="/referenz/refs/ft.refdata.tblgeduld.html" title="Geduldstufen">Geduldstufen</RouteLink> überhaupt angewendet werden. Sie beeinflussen damit direkt die Fakturierung und sollten nur vom Systemverwalter oder ARENAE verändert werden.</p>
<p>Die einzelnen Steuercodes sind hier definiert:</p>
<p><strong>Tabelle 21. Auslieferungssteuercodes</strong></p>
<table>
<thead>
<tr>
<th>Code</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Avi</td>
<td>Der Code bezeichnet das Avisierungssystem. Nur Auftragsarten/Versandardarten, für die dieser Code aktiviert ist, werden vom Avisierungsystem berücksichtigt.</td>
</tr>
<tr>
<td>NAbs</td>
<td>Der Code steht für „Nicht Absagen“. Ist er aktiviert, werden die entsprechenden Einträge in der Steuertabelle WBS berücksichtigt.</td>
</tr>
<tr>
<td>NAuf1</td>
<td>Der Code steht für „Nicht Aufbereiten“. Ist er aktiviert, werden die entsprechenden Einträge in der Steuertabelle WBS berücksichtigt.</td>
</tr>
<tr>
<td>NAvi1</td>
<td>Der Code steht für „Nicht Avisieren“. Ist er aktiviert, werden die entsprechenden Einträge in der Steuertabelle WBS berücksichtigt.</td>
</tr>
</tbody>
</table>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Auslieferungssystem-Steuertabelle</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Steuercode</dt>
<dd>Auslieferungs-Steuercode (siehe <a class="xref" href="ft.refdata.sysausl.html#tbl.auslieferungssteuercodes" title="Tabelle 21. Auslieferungssteuercodes">Tabelle 21, „Auslieferungssteuercodes“</a>).</dd>
<dt>Auftragsart</dt>
<dd>Eine <a class="link" href="ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</a>.</dd>
<dt>Verarbeitungsart</dt>
<dd>Eine <a class="link" href="ft.refdata.tblverarb.html" title="Verarbeitungsarten">Verarbeitungsart</a>.</dd>
<dt>Aktiv</dt>
<dd>Der angegebene Code ist für diese Kombination aus Auftragssart und Verarbeitungsart aktiv oder nicht.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/avisierungssystem.html" title="2. Avisierungssystem">Avisierungssystem</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.aufsteuer.html" title="Steuertabelle WBS">Steuertabelle-WBS</RouteLink></p>
</div></template>


